import './message-box.scss';
import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert} from 'react-bootstrap';
import {clearMessage, showError} from './message-box-actions';
import runtimeContext from '../environments/runtime-context';
import {SearchPageType} from '../search/search-config';
import {useTranslation} from 'react-i18next';

type InputProps = {
    id: string;
};

export const MessageBox = React.memo(({id}: InputProps) => {
    const [showAlert, setShowAlert] = useState(true);
    const dispatch = useDispatch();
    const messages = useSelector((state) => state.messages);
    const onClearMessage = useCallback(() => dispatch(clearMessage(id)), [dispatch, id]);
    const {t} = useTranslation();

    useEffect(() => {
        // handle error from ErrorBoundary
        const queryString = runtimeContext.getLocationQueryObject();
        const errorMessage = queryString.errormessage as string;
        if (errorMessage) {
            dispatch(showError(SearchPageType.BASIC, errorMessage));
        }
    }, [dispatch]);

    const message = messages[id];
    if (!message) {
        return null;
    }

    if (message.timeout > 0) {
        setTimeout(() => {
            setShowAlert(false);
            dispatch(clearMessage(id));
            setShowAlert(true);
        }, message.timeout);
    }

    if (!showAlert) {
        return null;
    }
    return (
        <Alert variant={message.severity} dismissible onClose={onClearMessage} className="message-alert">
            {message.heading && <h4>{t(message.heading)}</h4>}
            <p>{t(message.text)}</p>
        </Alert>
    );
});
